module.exports = __webpack_public_path__ + "img/04明钢.c0e07bef.jpg";